<template>
  <div class="healthcare-challenges">
    <div class="challenges-container">
      <h2 class="challenges-title">当前大健康行业面临的难题</h2>
      <div class="challenges-grid">
        <div class="challenge-card">
          <div class="card-header">
            <div class="card-icon"></div>
            <h3 class="card-title">客户<span class="highlight">信任度不足</span></h3>
          </div>
          <div class="card-content">
            <div class="challenge-item">
              <span class="item-icon">●</span>
              <span class="item-text">客户信任度低，专业背书不足，口碑传播周期长</span>
            </div>
          </div>
        </div>

        <div class="challenge-card">
          <div class="card-header">
            <div class="card-icon"></div>
            <h3 class="card-title">服务<span class="highlight">个性化不足</span></h3>
          </div>
          <div class="card-content">
            <div class="challenge-item">
              <span class="item-icon">●</span>
              <span class="item-text">服务个性化不足，缺乏健康数据积累与精准推荐</span>
            </div>
          </div>
        </div>

        <div class="challenge-card">
          <div class="card-header">
            <div class="card-icon"></div>
            <h3 class="card-title">用户<span class="highlight">留存率低</span></h3>
          </div>
          <div class="card-content">
            <div class="challenge-item">
              <span class="item-icon">●</span>
              <span class="item-text">用户留存率低，营销合规要求严格</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HealthcareChallenges",
}
</script>

<style lang="scss" scoped>
.healthcare-challenges {
  background: #f8fafe;
  padding: 80px 0;
}

.challenges-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.challenges-title {
  font-size: 36px;
  font-weight: 700;
  color: #2d2e30;
  text-align: center;
  margin: 0 0 60px 0;
  line-height: 1.2;
}

.challenges-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
}

.challenge-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 32px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
    transform: translateY(-4px);
  }
}

.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.card-icon {
  width: 4px;
  height: 32px;
  background: #3777f6;
  border-radius: 2px;
  margin-right: 16px;
}

.card-title {
  font-size: 20px;
  font-weight: 600;
  color: #2d2e30;
  margin: 0;
  line-height: 1.2;
  
  .highlight {
    color: #3777f6;
  }
}

.card-content {
  padding-left: 20px;
}

.challenge-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.item-icon {
  color: #c1ccdd;
  font-size: 12px;
  margin-right: 12px;
  margin-top: 6px;
  flex-shrink: 0;
}

.item-text {
  font-size: 14px;
  color: #5a5c60;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .healthcare-challenges {
    padding: 60px 0;
  }
  
  .challenges-title {
    font-size: 28px;
    margin-bottom: 40px;
  }
  
  .challenges-grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }
  
  .challenge-card {
    padding: 24px;
  }
  
  .card-title {
    font-size: 18px;
  }
}
</style> 